import { connect } from 'react-redux'
import { Component } from "react"
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

import{ onEditMode } from "../../actions" 
import {word3D}  from '../../game/loader';
import ActionPad from "./ActionPad"

const center = [39.63648, 21.47281]

const pathContext = {
    scene3D: null,
    zoom: 16,
    element3D: null,
    loading: false,
    position: null,
    version: 0,
    gltf: null,
    build_timer: null,
    id: `detail-map-${Math.random()}`,
    toSave: false
}

class DetailObject extends Component{
    constructor(props) {
        super(props)
        pathContext.element3D = props.element3D
        this.state = pathContext
    }

    async componentDidMount() {
        this.props.notification.addNotification("Scene3D", async (type, msg, arg)=>{
            setTimeout(async ()=>{
                let state = this.makeStateCopy()

                if(msg.container !== this.state.id) return
                state.loading = true

                const map = document.getElementById(this.state.id)
                if(!map.dataset.Scene3D && arg.map){ 
                    map.dataset.Scene3D = "ok"
                    state.scene3D = arg
                    
                    state.scene3D.map.setZoom(16)
                    //state.scene3D.map.dragPan.disable();
                    
                    /*if(this.props.element3D){ 
                        const lngLat = new window.maplibregl.LngLat(center[0], center[1])
                        const {x: x, y:y, z:z} = state.scene3D.map.getPosition3D(lngLat)

                        const loader = new GLTFLoader();
                        const file = `/${this.props.element3D.filename}`
                        const gltf = await loader.loadAsync(file) 
                        gltf.scene.position.set(x, y, z)
                        gltf.scene.scale.set(this.props.element3D.gltf.scene.scale.x*100, this.props.element3D.gltf.scene.scale.y*100, this.props.element3D.gltf.scene.scale.z*100)
                        gltf.scene.name = this.props.element3D.nom
                        state.scene3D.scene.add(gltf.scene)
                        map.dataset.gltf_id = this.props.element3D.id
                    }*/
                    state.loading = false
                    this.setState(state)
                    
                }
            }, 200)

            
            
        })

        this.props.notification.addNotification("zoom", async (type, msg, arg)=>{
            if(msg.container === this.props.map_id){
                const z = Math.floor(Math.round(msg.zoom))
                if(this.props.map && this.state.zoom !== z){ 
                    this.state.zoom = z
                    this.setState(this.state)
                    this.placeZoom(this.state.gltf, this.state.zoom)
                }
                
            }
            
        });
    }
    placeZoom(gltf, z){
        z = Math.floor(z)
        if(this.props.element3D.parameters && this.props.element3D.parameters.scale){
            const scale = this.props.element3D.parameters.scale
            if(scale[z]){ 
                gltf.scene.scale.set(scale[z].x, scale[z].y, scale[z].z)
            }
            else{
                for(z; z < 20; z++){
                    if(scale[z]){ 
                        gltf.scene.scale.set(scale[z].x, scale[z].y, scale[z].z)
                        break
                    }
                }
            }
        }
    }

    loadObject (){
        const map = document.getElementById(this.state.id)
        let state = this.makeStateCopy()

        if(this.props.position && this.state.scene3D){
            const coord = `${this.props.position.lng},${this.props.position.lat}`
            if(map.dataset.position !== coord){
                map.dataset.position = coord
                state.scene3D.map.setCenter(this.props.position)
            }
                
        }
        
        if(this.props.element3D.id !== parseInt(map.dataset.objectid||0)){
            //state.loading = true
            this.setState(state)
            const lngLat = new window.maplibregl.LngLat(center[0], center[1])

            

            const {x: x, y:y, z:z} = state.scene3D.map.getPosition3D(this.props.position || lngLat)
            state.scene3D.map.setCenter(this.props.position || lngLat)

            map.dataset.objectid = this.props.element3D.id

            if(state.gltf){
                state.scene3D.scene.remove(state.scene)    
            }

            let to_del = false
            do{
                to_del = false
                for(let i=0; i < state.scene3D.scene.children.length; i ++){
                    const t = state.scene3D.scene.children[i]
                    if(t.is_ifrit){
                        state.scene3D.scene.remove(t)
                        to_del = true
                        break
                    }
                }
            }
            while(to_del)
            const loader = new GLTFLoader();
            const file = `/${this.props.element3D.filename}`
            
            setTimeout(async ()=>{
                const gltf = await loader.loadAsync(file) 
                gltf.scene.position.set(x, y, z)
                gltf.scene.scale.set(this.props.element3D.gltf.scene.scale.x*100, this.props.element3D.gltf.scene.scale.y*100, this.props.element3D.gltf.scene.scale.z*100)

                if(this.props.element3D.parameters){
                    if(this.props.element3D.parameters.scale){
                        this.placeZoom(gltf, this.state.zoom)
                    }
                    if(this.props.element3D.parameters.rotate){
                        gltf.scene.rotation.set(this.props.element3D.parameters.rotate.x, this.props.element3D.parameters.rotate.y, this.props.element3D.parameters.rotate.z)
                    }
                }

                gltf.scene.name = this.props.element3D.nom
                
                
                gltf.scene.is_ifrit = true
                state.scene3D.scene.add(gltf.scene)
                state.gltf = gltf
                state.loading = false
                this.setState(state)
            }, 1)
            this.setState(state)
        }
        else if(this.props.element3D && this.props.element3D.id === parseInt(map.dataset.objectid) && state.gltf){
            const lngLat = new window.maplibregl.LngLat(center[0], center[1])
            const {x: x, y:y, z:z} = state.scene3D.map.getPosition3D(this.props.position || lngLat)
            state.gltf.scene.position.set(x, y + 10, z)
        }
    }

    makeStateCopy(){
        return {
            scene3D: this.state.scene3D,
            gltf: this.state.gltf,
            zoom: this.state.zoom,
            id: this.state.id,
            version: this.state.version + 1,
            loading: this.state.loading,
            element3D: this.state.element3D,
            build: this.state.build,
            position: this.state.position,
            toSave: this.state.toSave,   
        }
    }
    render() {
        setTimeout(()=>{
            const map = document.getElementById(this.state.id)
            if(map && !map.dataset.builded){ 
                map.dataset.builded = "ok"
                word3D(center, this.props, this.state.id, false)
            }


            /**/
            if(this.props.element3D && (!this.state.element3D || this.state.element3D.id !== this.props.element3D.id)){
                this.loadObject()
                
            }
        }, 10)
        return (
          <>
            <ActionPad position="bottomRigth" mode="template" gltf={this.state.gltf} map_id= {this.state.id} map={this.state.scene3D && this.state.scene3D.map ? this.state.scene3D.map:null} element3D={this.props.element3D}/>
            <div className={"detail-map"} id={this.state.id}></div>
            
          </>
        )
    }
}


const mapDispatchToProps = {
  onEditMode: onEditMode
}

const mapStateToProps = (state) => {  
    return {
        editMode: state.editMode,
        notification: state.notification
    }
}


DetailObject = connect(mapStateToProps, mapDispatchToProps)(DetailObject);

export default DetailObject;
